export default "__VITE_PUBLIC_ASSET__5e0c3ff2__"